
// export const server_url = !window.location.href.includes("localhost") ? "https://api.anano.com.br" : "http://localhost:8080"
export const server_url = "https://api.anano.com.br"
